import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }

import { onMounted } from 'vue';
import SOWReportingServiceProvider from '@/components/Utilization/SOWReportingServiceProvider.vue';
import TimeRatioReportingServiceProvider from '@/components/Utilization/TimeRatioReportingServiceProvider.vue';
import { useDateTime } from '@/composables';
import { useAuthStore, useUtilizationStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeUsage',
  setup(__props) {

const authStore = useAuthStore();
const utilizationStore = useUtilizationStore();

onMounted(async () => {
  await utilizationStore.getServiceProviderTimeUsageWidgetData(Number(authStore.user?.id));
});

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(utilizationStore).loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          class: "loader loader-height"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(SOWReportingServiceProvider, {
            "sow-data": _unref(utilizationStore).serviceProviderSOWTableData,
            "filter-date": _unref(useDateTime)().getMostRecentSunday()
          }, null, 8, ["sow-data", "filter-date"]),
          _createVNode(TimeRatioReportingServiceProvider, {
            "time-ratio-data": _unref(utilizationStore).serviceProviderTimeRatioTableData,
            "filter-date": _unref(useDateTime)().getMostRecentSunday()
          }, null, 8, ["time-ratio-data", "filter-date"])
        ], 64))
  ]))
}
}

})